import { render, staticRenderFns } from "./defaultTinyEmail.vue?vue&type=template&id=7980ef0b&scoped=true"
import script from "./defaultTinyEmail.vue?vue&type=script&lang=js"
export * from "./defaultTinyEmail.vue?vue&type=script&lang=js"
import style0 from "./defaultTinyEmail.vue?vue&type=style&index=0&id=7980ef0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7980ef0b",
  null
  
)

export default component.exports